export const CONTACT_EMAIL = "info@smrtin.net";
export const CURRENCIES = ["PKR", "AED", "OMR", "INR", "USD"];
// Countries without a configured plan currency see USD prices.
export const planCurrency = (c) => (CURRENCIES.includes(c) ? c : "USD");

export function formatPlanPrice(price, currency) {
  if (price == null) return "—";
  const n = Number(price);
  const dp = currency === "OMR" ? 3 : Number.isInteger(n) ? 0 : 2;
  return n.toLocaleString("en-US", { minimumFractionDigits: dp, maximumFractionDigits: dp });
}
